// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TaobaoOutlinedSvg from "@ant-design/icons-svg/es/asn/TaobaoOutlined";
import AntdIcon from '../components/AntdIcon';

var TaobaoOutlined = function TaobaoOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoOutlinedSvg
  }));
};

TaobaoOutlined.displayName = 'TaobaoOutlined';
export default React.forwardRef(TaobaoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TaobaoOutlined.js
// module id = 1927
// module chunks = 0